exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro[data-v-d6e78e42]{padding-top:80px;padding-bottom:80px}.highlighted-text[data-v-d6e78e42]{border-radius:1em 0 1em 0;background-image:linear-g radient(-100deg,rgba(247,198,2,.05),rgba(247,198,2,.5) 95%,rgba(247,198,2,0))}.border-green-500[data-v-d6e78e42]{border-style:solid}.child-flex>*[data-v-d6e78e42],.flex[data-v-d6e78e42]{-webkit-box-flex:inherit;-ms-flex:inherit;flex:inherit}.fa[data-v-d6e78e42]{margin-right:.5rem}", ""]);

// exports
